import React from 'react';

import Button from '~/components/core/Atomic/Buttons/Button';

interface DismissButtonProps {
  onDismiss: () => void;
  disabled?: boolean;
  label?: string;
}

export const DismissButton: React.FC<DismissButtonProps> = ({ onDismiss, disabled = false, label = 'Dismiss' }) => {
  return (
    <Button
      variant="text"
      classes={{
        root: 'text-slate-800 hover:text-slate-900 bg-slate-700/10 px-12',
      }}
      onClick={onDismiss}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};
